import React from "react";

/* ─── SVG Icons ─────────────────────────────────────────────────────────── */

const DocumentIcon = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff">
    <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z" />
  </svg>
);

const CameraIcon = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff">
    <path d="M9.4 2 7.8 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.8L14.6 2H9.4zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z" />
  </svg>
);

const GalleryIcon = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff">
    <path d="M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zM10.91 9.6l1.33 1.61 2.06-2.58L17.5 14H8.5l2.41-4.4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z" />
  </svg>
);

const VideoIcon = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff">
    <path d="M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z" />
  </svg>
);

const AudioIcon = () => (
  <svg viewBox="0 0 24 24" width="28" height="28" fill="#fff">
    <path d="M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z" />
  </svg>
);

/* ─── Sheet Items ───────────────────────────────────────────────────────── */

const items = [
  {
    key: "document",
    label: "Document",
    color: "#6D5DF6",
    Icon: DocumentIcon,
  },
  {
    key: "camera",
    label: "Camera",
    color: "#E91E63",
    Icon: CameraIcon,
  },
  {
    key: "gallery",
    label: "Gallery",
    color: "#B245FF",
    Icon: GalleryIcon,
  },
  {
    key: "videoCamera",
    label: "Video Camera",
    color: "#00A8E8",
    Icon: VideoIcon,
  },
  {
    key: "video",
    label: "Video",
    color: "#26C6DA",
    Icon: VideoIcon,
  },
  
];

/* ─── Component ─────────────────────────────────────────────────────────── */

export default function AttachmentSheet({
  open,
  onClose,
  fileInputRef,
  cameraInputRef,
  galleryInputRef,
  videoCameraInputRef,
  videoInputRef,
  audioInputRef,
}) {
  if (!open) return null;

  const openPicker = (key) => {
    onClose();

    switch (key) {
      case "document":
        fileInputRef?.current?.click();
        break;

      case "camera":
        // Opens device camera for taking photos.
        cameraInputRef?.current?.click();
        break;

      case "gallery":
        galleryInputRef?.current?.click();
        break;

      case "videoCamera":
        // Opens the device camera directly in VIDEO recording mode.
        videoCameraInputRef?.current?.click();
        break;

      case "video":
        // Opens the video picker.
        videoInputRef?.current?.click();
        break;

      default:
        break;
    }
  };

  return (
    <div
      className="fixed inset-0 z-[120] bg-black/30 flex items-end justify-center"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-t-[32px] bg-white dark:bg-neutral-900 px-6 pt-6 pb-8 shadow-2xl"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="grid grid-cols-3 gap-y-8 gap-x-4">
          {items.map((item) => (
            <button
              key={item.key}
              type="button"
              onClick={() => openPicker(item.key)}
              className="flex flex-col items-center gap-2"
            >
              <div
                className="w-16 h-16 rounded-full flex items-center justify-center shadow-md"
                style={{ backgroundColor: item.color }}
              >
                <item.Icon />
              </div>

              <span className="text-sm text-neutral-700 dark:text-neutral-200 text-center leading-tight">
                {item.label}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}